<template>
  <span v-on:click="onClick"
        class="order-by-component"
        :data-dusk="'order-by-' + header.title.toLowerCase()"
  >
    <slot></slot>

    <span
        v-if="loadPageObject && loadPageObject.orderBy === header.key"
        class="sort-icon-color"
        style="margin-top: -2px"
    >
      <arrow-up-icon v-if="ascending" type="up" title="Oplopend" />
      <arrow-down-icon v-if="descending" type="down" title="Aflopend" />
    </span>
    <span
        v-else
        class="sort-icon-color"
        style="margin-top: -2px"
    >
      <unfold-more-horizontal-icon title="Sorteerbaar" />
    </span>
  </span>
</template>

<script>
export default {
  name: "OrderByComponent",
  emits: ['change'],
  props: {
    header: {
      required: true,
      type: Object,
    },
    loadPageObject: {
      type: Object,
      required: false,
    }
  },
  computed: {
    ascending() {
      return this.loadPageObject?.order === 'asc';
    },
    descending() {
      return this.loadPageObject?.order === 'desc';
    },
  },
  methods: {
    onClick() {
      this.$emit('change',  this.header.key, (this.loadPageObject?.order === 'desc' ? 'asc' : 'desc'))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/_default.scss';
.order-by-component {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: $spacing-xxs ;
}

.order-by-component:hover {
  text-decoration: underline;
}

.sort-icon-color {
  color: #1890ff;
}
</style>
